import {AxiosRequestConfig, InternalAxiosRequestConfig} from "axios";
import {HttpClientService} from "data/services/http/http_client.service";
import {MLBStorage} from "data/utils/Storage";
import {set} from "lodash";

export abstract class HttpClientFactory {
	static createApiClient(config: AxiosRequestConfig) {
		// You can add interceptors here to adjust or modify any of requests/responses values.

		const xSidInterceptor = (config: InternalAxiosRequestConfig) => {
			const xSid = MLBStorage.GET("xSid") || "";
			if (xSid.length > 2) {
				set(config, "params.xSid", xSid);
			}
			return config;
		};

		const client = new HttpClientService(config);

		client.interceptors.request.use(xSidInterceptor);

		return client;
	}

	static createJSONClient(config: AxiosRequestConfig) {
		// You can add interceptors here to adjust or modify any of requests/responses values.
		return new HttpClientService(config);
	}
}
